import React from "react";
import { useTranslation } from "react-i18next";
import { useSelector } from "react-redux";
import { SelectDate } from "@activecollab/components";
import PropTypes from "prop-types";
import { getFirstWeekDay, getPersonalizedConfigOption } from "../../store/selectors/selector.configOptions.jsx";
import Angie from "../../utils/angie.jsx";

const SelectDateLoggedUser = ({ userNonWorkingDays, userNonWorkingDaysLabel, ...props }) => {
  const { t } = useTranslation();
  const dateFormat = useSelector((state) => getPersonalizedConfigOption(state, `format_date`));

  const firstDayOfWeek = useSelector((state) => getFirstWeekDay(state));

  return (
    <SelectDate
      {...props}
      dateFormat={Angie.functions.phpToMomentDateFormat(dateFormat)}
      firstDayOfWeek={firstDayOfWeek}
      saveButtonText={t("Save")}
      cancelButtonText={t("Cancel")}
      clearButtonText={t("Clear")}
      modalTitle={t("Save Changes")}
      modalDescription={t("You updated the date. Would you like to save this change?")}
      modalSaveBtnText={t("Save")}
      modalCancelBtnText={t("Discard")}
      nonWorkingDaysOfWeek={userNonWorkingDays}
      nonWorkingDaysOfWeekLabel={userNonWorkingDaysLabel}
    />
  );
};

SelectDateLoggedUser.propTypes = {
  userNonWorkingDays: PropTypes.array,
  userNonWorkingDaysLabel: PropTypes.string,
};

export default SelectDateLoggedUser;
